
import { types } from '~/utils/product-item-type'
import { thumbnailSizes, getDatoCmsThumbnail } from '~/utils/product-image'

export default {
  props: {
    src: {
      type: String,
      default: null,
    },
    size: {
      type: String,
      default: thumbnailSizes.MEDIUM,
    },
    type: {
      type: String,
      default: types.Bottle,
    },
    alt: {
      type: String,
      default: 'product thumbnail',
    },
  },
  data() {
    return {
      error: false,
    }
  },
  computed: {
    url() {
      return getDatoCmsThumbnail(this.src, this.size)
    },
  },
  created() {
    this.types = types
  },
}
